<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'

class Action {
  constructor() {
    this.type = null
    this.message = ''
    this.files = []
  }
}

export default {
  components: { ButtonAll, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    contractId: { type: Number, required: true },
    type: { type: String, required: true },
    hasDocument: { type: Boolean, default: true },
  },

  data() {
    return {
      fields: [],
      selected: false,
      action: new Action(),
    }
  },

  computed: {
    allowRef() {
      return this.type === 'ref'
    },
    allowDemand() {
      return ['transfer', 'reorganization', 'sell', 'demand', 'tel', 'address', 'sinister', 'rib'].includes(this.type)
    },
    allowRib() {
      return this.type === 'TO_REPLACE'
    },
  },

  methods: {
    openModal() {
      this.$refs.modalAction.open()
    },
    closeModal() {
      if (this.$refs?.file !== undefined) {
        this.$refs.file.value = null
        this.$refs.fileSpan.innerHTML = ''
      }

      this.selected = false
      this.action = new Action()
      this.$refs.modalAction.close(false)
    },
    handleDocument(e) {
      let fileName = ''
      let span = this.$refs.fileSpan

      if (e.target.files && e.target.files.length > 1)
        fileName = (e.target.getAttribute('data-multiple-caption') || '').replace('{count}', e.target.files.length)
      else fileName = e.target.value.split('\\').pop()

      span.innerHTML = fileName
      this.selected = true

      for (let fileIndex in e.target.files) {
        let file = e.target.files[fileIndex]

        if (file instanceof File) {
          const reader = new FileReader()

          reader.onload = () => {
            this.action.files.push(window.btoa(reader.result))
          }

          reader.readAsBinaryString(e.target.files[fileIndex])
        }
      }
    },
    send() {
      this.action.type = this.type

      this.postJSON('contracts/' + this.contractId + '/actions', this.action, {
        waitingTextT: 'contract.client.popin.' + this.type + '.waitingText',
        successTextT: 'contract.client.popin.' + this.type + '.successText',
      })
        .then((action) => {
          if (action.error !== undefined) {
            throw new Error(action.error)
          } else {
            this.closeModal()
          }
        })
        .catch((e) => alert(e))
    },
  },
}
</script>
<template>
  <ModalDialog
    id="modal-action"
    ref="modalAction"
    class-modal-dialog="modal-xl"
    :title-t="'contract.client.popin.' + type + '.title'"
    @icon-close="closeModal"
    e2e-modal="action"
  >
    <template #body>
      <div v-if="allowDemand">
        <label for="action-message" class="font-weight-bold col-form-label text-left">{{
          $t('contract.client.popin.' + type + '.label')
        }}</label>
        <div class="input-group">
          <textarea
            id="action-message"
            name="message"
            v-model="action.message"
            class="form-control"
            cols="40"
            rows="5"
          ></textarea>
        </div>

        <div
          v-if="hasDocument"
          class="d-flex justify-content-center align-items-center my-3"
          style="position: relative"
        >
          <label
            :for="'action-file-' + type"
            :ref="'label' + type"
            :id="'label' + type"
            :class="'btn ' + (selected ? 'btn-success' : 'btn-warning')"
            style="font-weight: 500"
            ><i class="fas fa-download"></i> {{ $t('contract.client.popin.' + type + '.file') }}</label
          >
          <input
            type="file"
            name="file"
            :id="'action-file-' + type"
            class="input__file--hidden"
            ref="file"
            data-multiple-caption="{count} fichiers sélectionnés"
            @change="handleDocument"
            multiple
          />
          <span ref="fileSpan" class="font-weight-bold ml-3"></span>
        </div>

        <p
          class="col-form-label text-left font-weight-bold"
          v-html="$t('contract.client.popin.' + type + '.message')"
        ></p>
      </div>
      <div v-if="allowRib">
        <p class="col-form-label text-left font-weight-bold" v-html="$t('contract.client.popin.rib.label')"></p>
        <div class="my-3" style="position: relative">
          <label
            for="action-file-rib"
            ref="labelrib"
            id="labelrib"
            :class="'btn ' + (selected ? 'btn-success' : 'btn-warning')"
            style="font-weight: 500"
            ><i class="fas fa-download"></i> {{ $t('contract.client.popin.rib.file') }}</label
          >
          <input
            type="file"
            name="file"
            id="action-file-rib"
            class="input__file--hidden"
            ref="file"
            data-multiple-caption="{count} fichiers sélectionnés"
            @change="handleDocument"
            multiple
          />
          <span ref="fileSpan" class="font-weight-bold ml-3"></span>
        </div>
        <p class="col-form-label text-left font-weight-bold" v-html="$t('contract.client.popin.rib.info')"></p>
        <p class="col-form-label text-left font-weight-bold" v-html="$t('contract.client.popin.rib.message')"></p>
      </div>
      <div v-if="allowRef">
        <label for="action-ref" class="font-weight-bold col-form-label text-left">{{
          $t('contract.client.popin.' + type + '.label')
        }}</label>
        <div class="input-group">
          <input id="action-ref" name="message" v-model="action.message" class="form-control" />
        </div>
        <div
          v-if="hasDocument"
          class="d-flex justify-content-center align-items-center my-3"
          style="position: relative"
        >
          <label
            :for="'action-file-' + type"
            :ref="'label' + type"
            :id="'label' + type"
            :class="'btn ' + (selected ? 'btn-success' : 'btn-warning')"
            style="font-weight: 500"
            ><i class="fas fa-download"></i> {{ $t('contract.client.popin.' + type + '.file') }}</label
          >
          <input
            type="file"
            name="file"
            :id="'action-file-' + type"
            class="input__file--hidden"
            ref="file"
            data-multiple-caption="{count} fichiers sélectionnés"
            @change="handleDocument"
            multiple
          />
          <span ref="fileSpan" class="font-weight-bold ml-3"></span>
        </div>
      </div>
    </template>
    <template #footer>
      <ButtonAll type="information" margin="no" @click="closeModal" label="button.cancel" />
      <ButtonAll type="validation" margin="no" @click="send" label="contract.client.popin.address.send" />
    </template>
  </ModalDialog>
</template>
